// 加载插件
const modules = import.meta.globEager('./*.ts')
const moduleChildren = import.meta.globEager('./**/*.ts')

const requirePlugin: any[] = []

Object.keys(modules).forEach((key) => {
  requirePlugin.push(key)
})

Object.keys(moduleChildren).forEach((key) => {
  requirePlugin.push(key)
})
